module.exports = __webpack_public_path__ + "static/media/item-border-2.96432cd9.svg";